import { z } from 'zod'

// ─── Public-facing schema (create / update inputs) ────────────────────────────

export const eventCreateSchema = z.object({
	name: z.string().min(1),
	description: z.string().optional(),
	isActive: z.boolean().default(true),
})

export const eventUpdateSchema = eventCreateSchema.partial()

export type EventCreateInput = z.infer<typeof eventCreateSchema>
export type EventUpdateInput = z.infer<typeof eventUpdateSchema>
